import React from "react";
import { useParams, Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import { CASE_STUDIES } from "../data/staticData";
import { Quote, ArrowUpRight } from "lucide-react";

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const c = CASE_STUDIES.find((x) => x.slug === slug);
  if (!c) return <SiteLayout><div className="max-w-3xl mx-auto px-6 py-32 text-center"><h1 className="font-display text-4xl font-bold">Case study not found</h1></div></SiteLayout>;

  return (
    <SiteLayout>
      <section className="pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="eyebrow mb-4">{c.industry} · case study</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">{c.title}</h1>
          <p className="mt-4 text-inkSoft">Client · <span className="text-ink">{c.client}</span></p>
          <div className="mt-8 rounded-3xl overflow-hidden border border-line">
            <img src={c.image} alt="" className="w-full max-h-[420px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
          {c.metrics.map((m) => (
            <div key={m.label} className="card-soft p-6">
              <div className="text-[11px] uppercase tracking-widest text-inkSoft">{m.label}</div>
              <div className="font-mono text-3xl font-semibold tracking-tighter mt-2">{m.delta}</div>
              <div className="text-xs text-inkSoft mt-1 font-mono">{m.before} → {m.after}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose-block space-y-8">
          <div>
            <div className="eyebrow mb-2">Challenge</div>
            <p className="text-lg leading-relaxed">{c.challenge}</p>
          </div>
          <div>
            <div className="eyebrow mb-2">Strategy</div>
            <p className="text-lg leading-relaxed">{c.strategy}</p>
          </div>
          <div>
            <div className="eyebrow mb-2">Services used</div>
            <div className="flex flex-wrap gap-2">{c.services.map((s) => <span key={s} className="tag">{s}</span>)}</div>
          </div>
          <figure className="card-soft p-7 not-italic">
            <Quote className="text-terra mb-3" />
            <blockquote className="font-display text-xl leading-snug">"{c.quote}"</blockquote>
            <figcaption className="mt-4 text-sm text-inkSoft">— {c.author}</figcaption>
          </figure>
        </div>
      </section>

      <section className="py-20 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h3 className="font-display text-3xl font-bold tracking-tight">Want results like {c.client}?</h3>
          <p className="mt-4 text-inkSoft">Start with a link building or digital PR campaign built around the same playbook.</p>
          <Link to="/signup" className="btn-primary mt-6">Start a campaign <ArrowUpRight size={18} /></Link>
        </div>
      </section>
    </SiteLayout>
  );
}
